import styled from "styled-components";

// ─── Layout primitives ───────────────────────────────────

export const Container = styled.div`
    display: flex;
    flex-direction: column;
    gap: 25px;
    padding: 20px;
    overflow-y: auto;
    height: 100%;
`;

export const SectionTitle = styled.h5`
    font-size: 16px;
    font-weight: 600;
    color: #333;
    margin: 0;
`;

export const Card = styled.div`
    background-color: #fff;
    border: 1px solid #e8e8e8;
    border-radius: 10px;
    padding: 20px 24px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);
`;

export const CardTitle = styled.h6`
    font-size: 14px;
    font-weight: 600;
    color: #2c2c2c;
    margin: 0 0 18px 0;
    padding-bottom: 12px;
    border-bottom: 1px solid #f0f0f0;
    letter-spacing: 0.2px;
`;

export const SectionHeader = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 0 0 18px 0;
    padding-bottom: 12px;
    border-bottom: 1px solid #f0f0f0;
`;

export const ResetIconButton = styled.button<{ mainColor: string }>`
    display: flex;
    align-items: center;
    gap: 6px;
    padding: 6px 10px;
    background-color: transparent;
    color: ${({ mainColor }) => mainColor};
    border: 1px solid ${({ mainColor }) => mainColor};
    border-radius: 6px;
    font-size: 12px;
    font-weight: 500;
    cursor: pointer;
    transition: all 0.2s ease;

    &:hover {
        background-color: ${({ mainColor }) => mainColor};
        color: #fff;
    }

    svg {
        width: 14px;
        height: 14px;
    }
`;

export const SmallToggle = styled.button<{
    isActive: boolean;
    mainColor: string;
}>`
    width: 40px;
    height: 22px;
    border-radius: 11px;
    border: none;
    background-color: ${({ isActive, mainColor }) =>
        isActive ? mainColor : "#ccc"};
    position: relative;
    cursor: pointer;
    transition: background-color 0.2s ease;
    flex-shrink: 0;

    &::after {
        content: "";
        position: absolute;
        top: 2px;
        left: ${({ isActive }) => (isActive ? "20px" : "2px")};
        width: 18px;
        height: 18px;
        border-radius: 50%;
        background-color: white;
        transition: left 0.2s ease;
    }
`;

// ─── Language list primitives ────────────────────────────

export const LanguageItem = styled.div`
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 10px 0;
    border-bottom: 1px solid #f0f0f0;

    &:last-child {
        border-bottom: none;
    }
`;

export const LanguageCodeBadge = styled.div<{
    enabled: boolean;
    mainColor: string;
}>`
    width: 32px;
    height: 32px;
    border-radius: 6px;
    background-color: ${({ enabled, mainColor }) =>
        enabled ? mainColor : "#e0e0e0"};
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    transition: background-color 0.2s ease;
    font-size: 11px;
    font-weight: 700;
    color: white;
`;

export const LanguageLabelText = styled.span`
    font-size: 13px;
    font-weight: 500;
    color: #333;
    flex: 1;
`;

export const DefaultLanguageBadge = styled.button<{
    isDefault: boolean;
    mainColor: string;
}>`
    padding: 4px 10px;
    border-radius: 12px;
    border: 1px solid
        ${({ isDefault, mainColor }) => (isDefault ? mainColor : "#d0d0d0")};
    background-color: ${({ isDefault, mainColor }) =>
        isDefault ? mainColor : "transparent"};
    color: ${({ isDefault }) => (isDefault ? "#fff" : "#888")};
    font-size: 10px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.2s ease;
    white-space: nowrap;

    &:hover {
        border-color: ${({ mainColor }) => mainColor};
        color: ${({ isDefault, mainColor }) =>
            isDefault ? "#fff" : mainColor};
    }

    &:disabled {
        cursor: not-allowed;
        opacity: 0.5;
    }
`;
